export default "__VITE_ASSET__2127a279__"